import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AppClientResourcesModule, ApplicationClientCommonModule, MaterialModule, ServiceResponseModule } from '@sdbn/appclient';
import { ColorPickerModule } from 'src/tmc-common/components/color-picker/color-picker.module';
import { InputIntegerModule } from 'src/tmc-common/components/input-integer/input-integer.module';
import { TransportOptionsAdministrationComponent } from './component/admin-component/transport-options-administration.component';
import { TransportOptionsStructureEditorComponent } from './component/structure-editor/transport-options-strcuture-editor.component';

import { DictionaryModule } from '@sdbn/appclient';
import { CommonLayoutModule, CommonTranslationModule, CommonUIModule } from '@sdbn/common';
import { ConstraintOptionAssignmentEditorComponent } from './component/constraint-option-assignment-editor/constraint-option-assignment-editor.component';
import { TimePriorityListComponent } from './component/time-priority-list/time-priority-list.component';
import { TransportOptionConstraintsEditorComponent } from './component/transport-option-constraints/transport-option-constraints-editor.component';
import { TransportOptionEditorControlComponent } from './component/transport-option-editor-control/transport-option-editor-control.component';
import { TransportOptionEditorLabelingComponent } from './component/transport-option-editor-labeling/transport-option-editor-labeling.component';
import { TransportOptionEditorLoadingComponent } from './component/transport-option-editor-loading/transport-option-editor-loading.component';
import { TransportOptionEditorParameterComponent } from './component/transport-option-editor-parameter/transport-option-editor-parameter.component';
import { TransportOptionEditorValidationComponent } from './component/transport-option-editor-validation/transport-option-editor-validation.component';
import { TransportOptionEditorFilesComponent } from './component/transport-option-editor-files/transport-option-editor-files.component';
import { AppClientComponentModule } from '@sdbn/appclient';
import { TransportOptionEditorComponent } from './component/transport-option-editor/transport-option-editor.component';




@NgModule({
  declarations: [
    TransportOptionsAdministrationComponent,
    TransportOptionsStructureEditorComponent,
    TransportOptionEditorComponent,
    TimePriorityListComponent,
    TransportOptionConstraintsEditorComponent,
    ConstraintOptionAssignmentEditorComponent,
    TransportOptionEditorControlComponent,
    TransportOptionEditorLabelingComponent,
    TransportOptionEditorLoadingComponent,
    TransportOptionEditorParameterComponent,
    TransportOptionEditorValidationComponent,
    TransportOptionEditorFilesComponent
  ],
  imports: [
    CommonModule,
    CommonUIModule,
    CommonLayoutModule,
    DictionaryModule,
    MaterialModule,
    ReactiveFormsModule,
    FormsModule,
    InputIntegerModule,
    ColorPickerModule,
    ApplicationClientCommonModule,
    ServiceResponseModule,
    CommonTranslationModule,
    AppClientComponentModule,
    AppClientResourcesModule
  ],
  exports: [
  ]
})
export class TransportOptionsAdministrationModule { }
